import React from 'react'
import classnames from 'classnames'

import { Layout } from 'src/components/Layout'

import './styles.less'

const Footer = ({ children, style, padder, multi, fixed, className }) => {
  const getClassNames = classnames('footer', className, {
    padder,
    multi,
    fixed
  })
  return (
    <Layout.Footer className={getClassNames} style={style}>
      { children }
    </Layout.Footer>
  )
}

Footer.defaultProps = {
  padder: false,
  fixed: false,
  multi: false
}

export default Footer
